import {Component} from "@angular/core";

@Component({
  selector: 'payment-canceled',
  template: require('./payment-canceled.component.html'),
  styles: [
    require('./payment-canceled.component.scss')
  ]
})
export class PaymentCanceledComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/payment/canceled/payment-canceled.component.ts